import * as React from 'react';
import { SVGProps } from 'react';

const IconPrinterFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 1a1 1 0 0 0-1 1v1h10V2a1 1 0 0 0-1-1H4ZM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1V8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v4h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2Z" />
    <path d="M11 9H5v6h6V9Z" />
  </svg>
);
export default IconPrinterFilledSizeS;
